// @ts-check

var FfProductCard = class extends HTMLElement {
  constructor() {
    super();

    const { ffProductId, ffGender } = this.dataset;

    if (!ffProductId) return;

    this.addEventListener("click", () => {
      const productsGender = JSON.parse(
        localStorage.getItem("ff_products_gender") || "{}"
      );

      productsGender[ffProductId] = ffGender;

      localStorage.setItem(
        "ff_products_gender",
        JSON.stringify(productsGender)
      );
    });
  }
};

window.customElements.define("ff-product-card", FfProductCard);
